// Allowed file extensions that users can upload.
export const ALLOWED_EXTENSIONS = ".txt, .doc, .docx, .pdf, .jpg, .jpeg, .png, .gif, .tif, .tiff, .xlsx, .xls, .zip";
